import templateUrl from '../timeline-template2.html';

export const timelineMultipleQuestionsComponent = {
    bindings: {
        details: '<',
        onGoBack: '&',
        onSubmit: '&',
        onCancel: '&',
        disableButtons: '<',
        isAdded: '@',
    },
    templateUrl,
    controller: class TimelineMultipleQuestionsComponent {
        constructor(Constants, $scope, toastr, $stateParams, $timeout, CompareObjectService, $anchorScroll, DateService, AuthService, ModalService, ApiService) {
            'ngInject';
            this.constants = Constants;
            this.toastr = toastr;
            this.$scope = $scope;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            this.CompareObjectService = CompareObjectService;
            this.$anchorScroll = $anchorScroll;
            this.dateService = DateService;
            this.authService = AuthService;
            this.modalService = ModalService;
            this.apiService = ApiService;
            this.totalErrors = [];
            this.isEnable = false;
        }

        $onInit() {
            this.questionTypeId = 0;
            this.details.noOfQuestions = this.details.noOfQuestions;
            this.details.taskList = this.getQuestions();
            this.items = [];
            this.item = {
                id: '',
                title: '',
                status: -1
            };
            this.totalNumberOfQuestion = this.details.taskList.length
            this.saveData = angular.copy(this.details);
        }
        onChangeQuestionOption(questionIndex, optionIndex) {
            if (this.details.questions[questionIndex].status !== 0) {
                this.details.questions[questionIndex].status = 1
            }
        }
        onAdd() {
            this.details.questions.map(({ isSelect, options }) => {
                if (isSelect) {
                    if (options.length < 5) {
                        options.push({
                            id: options.length,
                            title: '',
                        })
                    }
                    else {
                        this.toastr.error('maximum 5 Option Only');
                    }
                }
            })
        }
        onDelete(_index) {
            this.details.taskList.map(({ isSelect, options, status }, index) => {
                if (isSelect) {
                    options.splice(_index, 1)
                    if (this.details.questions[index].status !== 0) {
                        this.details.questions[index].status = 1
                    }
                }

            })

        }
        onDeleteQuestion(_index, data) {
            let bodyMsg = data.isTaskPerformed ? 'There are users who have completed the task, are you sure to delete this task?' : 'Are you sure to delete this task?'
            this.modalService.open({
                details: {
                    bodyMessage: bodyMsg,
                },
                buttons: [{
                    name: 'No',
                    action() {
                    }
                }, {
                    name: 'Yes',
                    isPrimary: true,
                    action: _onDelete.bind(this, _index)
                }]
            });
            function _onDelete(data) {
                this._deleteTask(data);
            }
        }

        _deleteTask(_index) {

            if (this.details.taskList.length > 1 && this.totalNumberOfQuestion > 1) {
                this.totalNumberOfQuestion -= 1
                if (this.isAdded === "true" || this.details.taskList[_index].status === 0) {
                    this.details.taskList.splice(_index, 1)
                } else {
                    this.details.taskList[_index].status = 2
                }

            }
            else {
                this.toastr.error('At Least one Question has to be here');
            }
        }
        onQuestionTitleChange(index) {
            if (this.details.taskList[index].status !== 0) {
                this.details.taskList[index].status = 1
            }
        }
        _onIsMandetoryChange(index) {
            this.details.questions[index].isMandatory = parseInt(event.id);
            if (this.details.questions[index].status !== 0) {
                this.details.questions[index].status = 1
            }
        }
        getQuestions() {
            if ((this.details.taskList.length === this.details.noOfQuestions) || (this.details.taskList.length > this.details.noOfQuestions)) {
                return this.details.taskList
            } else if (this.details.noOfQuestions > this.details.taskList.length && this.details.taskList.length !== 0) {
                const arr = [...this.details.taskList]
                let i;
                for (i = arr.length - 1; i < this.details.noOfQuestions - 1; i++) {
                    arr.push({
                        description: "",
                        index: i,
                        id: i + 1,
                        title: '',
                        isMandatory: 1,
                        options: [],
                        isSelect: false,
                        status: 0,
                        plainDescription: "",
                        isValid: false

                    })
                }
                return arr
            }
            else if (this.details.taskList.length === 0) {
                const arr = []
                let i;
                for (i = 0; i <= this.details.noOfQuestions - 1; i++) {
                    let data = {
                        index: i,
                        id: i + 1,
                        title: '',
                        field_type: '',
                        questionTypeId: null,
                        isMandatory: 1,
                        options: [],
                        description: "",
                        isSelect: i === 0 ? true : false,
                        status: 0,
                        plainDescription: "",
                        isValid: false,
                    }
                    let _data = Object.assign({}, data)

                    arr.push(_data)
                }
                return arr
            } else {
                const arr = [...this.details.taskList]
                let i;
                for (i = this.details.taskList.length - 1; i < this.details.taskList - 1; i++) {
                    arr.push({
                        index: i,
                        id: i + 1,
                        title: '',
                        isMandatory: 1,
                        isSelect: false,
                        status: 0,
                        plainDescription: "",
                        isValid: false

                    })
                }
                return arr
            }
        }
        accordianBodyDisplay(index) {
            this.details.taskList.map((schedule, _index) => {
                if (_index === index) {
                    schedule.isSelect = !schedule.isSelect;
                } else {
                    schedule.isSelect = false;
                }
            });
        }
        onGoBackClick() {
            const modifyTaskList = this.details.taskList.reduce((acc, task) => {
                if (task.status !== 0) {
                    acc.push(task)
                }
                return acc
            }, [])
            this.details.taskList = modifyTaskList;
            this.onGoBack(this.details);
        }
        onCancel() {
            this.onCancel();
        }
        showNoOfErrorsInForm(questions) {
            return questions.map((schedule) => {
                if (schedule.status !== 2) {
                    if (((schedule.plainDescription === "") && (schedule.timelineId === null)) ||
                        (schedule.plainDescription === "") || (schedule.timelineId === null)) {
                        schedule.error = '1 Errors';
                        schedule.isValid = false

                    }
                    else {
                        schedule.error = '';
                        schedule.isValid = true
                    }
                }
                else {
                    schedule.error = '';
                }
                return schedule;
            });
        }
        _onSubmit() {
            // const isUpdated = this.CompareObjectService.deepCompareObjectHasChanged(this.savedata, this.details, false)
            this.details.taskList = this.showNoOfErrorsInForm(this.details.taskList);
            this.totalErrors = this.details.taskList.filter((taks) => taks.isValid === false)
            if (this.totalErrors.length === 0) {
                this.onSubmit({
                    $event: {
                        details: this.details
                    }
                });
            }
        }

    }
};



// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-multiple-questions/timeline-multiple-questions.component.js